import { lazy } from 'react';
import Loadable from 'components/Loadable';

const PayrollDashboard = Loadable(lazy(() => import('./components/payroll-dashboard/PayrollDashboard')));
const ClientStaffPayroll = Loadable(lazy(() => import('./components/client-staff-payroll/ClientStaffPayroll')));
const PayrollRun = Loadable(lazy(() => import('./components/payroll-run/PayrollRun')));
const SalaryStructure = Loadable(lazy(() => import('./components/salary-structure/SalaryStructure')));
const EmployeePayrollSetup = Loadable(lazy(() => import('./components/employee-payroll-setup/EmployeePayrollSetup')));
const Payslips = Loadable(lazy(() => import('./components/payslips/Payslips')));
const PayrollReports = Loadable(lazy(() => import('./components/payroll-reports/PayrollReports')));

export const payrollRoutes = {
  path: 'payroll',
  children: [
    { index: true, element: <PayrollDashboard /> },
    { path: 'dashboard', element: <PayrollDashboard /> },
    { path: 'client-staff', element: <ClientStaffPayroll /> },
    { path: 'run', element: <PayrollRun /> },
    { path: 'salary-structure', element: <SalaryStructure /> },
    { path: 'employee-payroll', element: <EmployeePayrollSetup /> },
    { path: 'payslips', element: <Payslips /> },
    { path: 'reports', element: <PayrollReports /> }
  ]
};

export default payrollRoutes;
